export enum RecaptchaActionType {
  RESET_PASSWORD = 'resetPassword',
  SIGN_UP = 'signUp',
  VERIFY_PHONE = 'verifyPhone',
}
